// @ts-strict-ignore
import { getHashParam } from 'helpers/url';
import { isGhostLogin, loadCredentialsFromCookies, storeCredentials } from 'services/auth/auth-storage-manager';

function credentialsExistInHash(): boolean {
  return !!getHashParam('access_token');
}

export function saveCredentials(): void {
  if (credentialsExistInHash()) {
    // We are freshly logged in by accounts.
    // Save the credentials for the next couple of days, so we're not logged out after refresh.

    const token = getHashParam('access_token');
    const scopesString = getHashParam('scope');
    const expiresIn = getHashParam('expires_in');
    const isGhost = getHashParam('frenzied') === '1';

    if (token && scopesString) {
      storeCredentials({ token, scopesString, isGhost, expiresIn });
    }
  }

  if (!isGhostLogin()) {
    loadCredentialsFromCookies();
  }
}
